export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7263.6c76ea5d.jpg";